(() => {
  const UPDATE_EVENT = 'dynamic-pricing:cart-update';
  const PRODUCT_TYPES = ['Bag', 'Pod'];

  const calculateTotalQuantity = () => {
    const totalQuantity = {
      autodeliver: {
        Bag: 0,
        Pod: 0,
      },
      onetime: {
        Bag: 0,
        Pod: 0,
      },
    };

    const cartItems = window.dynamicPricing?.cart?.items;

    if (Array.isArray(cartItems)) {
      cartItems.forEach((item) => {
        const productType = window.productTypes[item.product_id] || item.product_type;

        if (!PRODUCT_TYPES.includes(productType)) return;

        const purchaseType = item.selling_plan_allocation
          ? 'autodeliver'
          : 'onetime';
        const quantity = Number(item.quantity);

        if (!Number.isFinite(quantity) || quantity <= 0) return;

        totalQuantity[purchaseType][productType] += quantity;
      });
    }

    if (window.dynamicPricing) {
      window.dynamicPricing.totalQuantity = totalQuantity;
    }
  };

  calculateTotalQuantity();
  document.addEventListener(UPDATE_EVENT, calculateTotalQuantity);
})();
